<script setup lang="ts">
import { formatFileSize } from '@/modules/documents-new/utils/fileHelpers'
import universal from '@images/icons/files/universal.svg'
import xsl from '@images/icons/files/xls.svg'
import pdf from '@images/icons/files/pdf.svg'
import doc from '@images/icons/files/doc.svg'
import jpg from '@images/icons/files/jpg.svg'

const props = defineProps<{
  name: string
  size: number
}>()

/* Те же иконки, что в FileAttach */
const fileIcon = computed(() => {
  const extension = props.name.split('.').pop()?.toLowerCase()
  switch (extension) {
    case 'xls': case 'xlsx': return xsl
    case 'pdf': return pdf
    case 'doc': case 'docx': return doc
    case 'jpg': case 'jpeg': case 'png': case 'gif': return jpg
    default: return universal
  }
})

const emit = defineEmits<{
  remove: []
}>()
</script>

<template>
  <div class="import-file-chip">
    <VIcon :icon="fileIcon" size="24" />
    <div class="import-file-chip__text">
      <span class="import-file-chip__name">{{ name }}</span>
      <span class="import-file-chip__size">{{ formatFileSize(size) }}</span>
    </div>
    <button
      type="button"
      class="import-file-chip__close"
      aria-label="Удалить файл"
      @click="emit('remove')"
    >
      <VIcon icon="ri-close-line" size="16" />
    </button>
  </div>
</template>

<style scoped lang="scss">
.import-file-chip {
  display: flex;
  flex: none;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 515px;
  max-width: 100%;
  height: 42px;
  padding: 4px 12px 5px;
  background: rgb(var(--v-theme-primary), var(--v-selected-opacity));
  border-radius: 6px;
}

.import-file-chip__text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}

.import-file-chip__name {
  overflow: hidden;
  font-size: 0.8125rem;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.import-file-chip__size {
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  font-size: 0.75rem;
  line-height: 14px;
}

.import-file-chip__close {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  margin-inline-start: auto;
  padding: 0;
  border: none;
  background: transparent;
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  cursor: pointer;
}
</style>
